const translations = {
  'fields.name': 'Nombre',
  'fields.status': 'Estado',
  'fields.description': 'Descripción',
  'fields.fieldValues': 'Campos adicionales',
  'fields.place': 'Destino',
  'fields.priority': 'Prioridad',
  'fields.user': 'Responsable',
  'fields.createdBy': 'Responsable',
  'fields.group': 'Grupo',
  'fields.documents': 'Documentos',
  'fields.asset': 'Activos',
  'fields.scheduling': 'Programación',
  'fields.events': 'Eventos',
  'fields.address': 'Dirección',
  by: 'por',
  anonymous: 'Anónimo',
  yes: 'sí',
  no: 'no',
  operation: 'Operación',
  date: 'Fecha',
  operationDetails: 'Detalles de la operación',
  seeDetails: 'Ver detalles',
  'operations.create': 'Creación',
  'operations.update': 'Modificación',
  'operations.remove': 'Eliminación',
  'operations.notSupported': 'No soportada'
}

export default translations
